import BrandLogo from "@/components/BrandLogo";
import Button from "@/components/Button";
import Container from "@/components/Container";
import Page from "@/components/Page";

export default function ErrorBoundaryFallback() {
  const refresh = () => {
    window.location.reload();
  };

  return (
    <Container>
      <BrandLogo />

      <Page justifyContent="flex-end">
        <h1>Något gick fel.</h1>

        <Button onClick={refresh}>Ladda om sidan</Button>
      </Page>
    </Container>
  );
}
